export type VideoSourceFields = {
  filesVideoUrl?: string;
  remoteVideoPlayer?: string;
  remoteVideoMp4Url?: string;
  remoteVideoUrl?: string;
};

const getIframeSrc = (remoteVideoPlayer?: string): string | undefined => {
  if (!remoteVideoPlayer?.includes('iframe')) {
    return undefined;
  }

  const doc = new DOMParser().parseFromString(remoteVideoPlayer, 'text/html');
  const src = doc.querySelector('iframe')?.getAttribute('src');
  return src || undefined;
};

/**
 * Resolves the playable source URL from video asset fields.
 *
 * Resolution order:
 * 1. filesVideoUrl (files.video.url) — direct uploaded/transcoded video file
 * 2. remoteVideoPlayer iframe src
 * 3. remoteVideoMp4Url (remote_video.properties.mp4_url) — provider mp4 URL
 * 4. remoteVideoUrl (remote_video.properties.url) — provider fallback URL
 *
 * Returns undefined when no source can be resolved.
 * Callers are responsible for type-gating (only call for video-type assets).
 */
export const getVideoSourceUrl = ({
  filesVideoUrl,
  remoteVideoPlayer,
  remoteVideoMp4Url,
  remoteVideoUrl,
}: VideoSourceFields): string | undefined => {
  return (
    filesVideoUrl ||
    getIframeSrc(remoteVideoPlayer) ||
    remoteVideoMp4Url ||
    remoteVideoUrl ||
    undefined
  );
};
